import * as React from 'react';
import { Grid, Typography} from '@material-ui/core';
import { useContext } from 'react';
import { AuthContext } from '../_auth/AuthContext';
import Policies from '../common/Policy/Policies';
import { IObjectPolicy, IPolicyObject } from '../_types/ewpolicy';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import GiftCards from './_gift_card';

interface Props {

};

const LocationHome: React.FC<Props> = (prop: Props) => {

    const { user } = useContext(AuthContext);


    React.useEffect(() => {

    }, [])

    const policyChange = (c: IObjectPolicy) => {

    };

    const useStyles = makeStyles((theme: Theme) =>
        createStyles({
        spinner: {
            marginLeft: 5,
            color: 'primary',
        },
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120,
        },
        selectEmpty: {
            marginTop: theme.spacing(2)
        },
        header: {
            marginBottom: theme.spacing(1),
            marginTop: theme.spacing(1)
        }
        }),
    );
    const classes = useStyles();

    return (
        <Grid container direction="column" justify="flex-start" alignItems="stretch">
            {(user.currentLocation) && (
                <React.Fragment>    
                    <Grid item>
                        <GiftCards locationId={user.currentLocation.id} />
                    </Grid>
                    <Grid item>
                        <Typography variant="h6" className={classes.header}>Policies</Typography>
                    </Grid>
                    <Grid item>
                        <Policies policyObject={user.currentLocation! as IPolicyObject} onChange={policyChange} />
                    </Grid>
                </React.Fragment>)}
        </Grid>
    )
}

export default LocationHome;